import { useState, useRef } from 'react'
import uuid from 'react-uuid'

export const useField = (type, defaultValue = '') => {
  const [value, setValue] = useState(defaultValue)

  const id = useRef(uuid()).current

  const onChange = (event) => {
    if (event === undefined) return

    let newValue

    if (typeof event === 'string') {
      newValue = event
    } else if (event.target) {
      newValue = event.target.value
    } else {
      newValue = event
    }

    if (type === 'number' && typeof newValue === 'string') {
      newValue = newValue.replace(',', '.')
    }
    console.log(newValue, typeof newValue)

    setValue(newValue)
  }

  return {
    type,
    value,
    onChange,
    id
  }
}
